import moment from 'moment';
import * as constants from '../util/constants';
import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    const campaignsAndSalesOptInForm = $('.campaigns-and-sales-opt-in-form');
    if (campaignsAndSalesOptInForm.length) {
      campaignsAndSalesOptInForm.on('submit', function() {
        const thisCampaignsAndSalesOptInForm = $(this);
        const emailFields = thisCampaignsAndSalesOptInForm.find('.form-field.form-field-email');
        const requiredFields = thisCampaignsAndSalesOptInForm.find('.form-field.is-required');
        const formFieldNotices = thisCampaignsAndSalesOptInForm.find('.form-field-notice');
        const formMessage = thisCampaignsAndSalesOptInForm.find('.form-message');

        emailFields.removeClass('form-field-error');
        requiredFields.removeClass('form-field-error');
        formFieldNotices.remove();
        formMessage.hide();
        formMessage.html('');
        formMessage.removeClass('has-error');

        let hasError = false;

        if (emailFields.length) {
          emailFields.each(function() {
            const thisEmailField = $(this);
            const formInput = thisEmailField.find('.form-input');
            const email = formInput.val();

            if (thisEmailField.is(':visible') && (email === '' || email === null || !helpers.isValidEmail(email))) {
              hasError = true;

              thisEmailField.addClass('form-field-error');
              thisEmailField.append('<div class="form-field-notice form-field-error-message">Please enter a valid email address.</div>');
            }
          });
        }

        if (requiredFields.length) {
          requiredFields.each(function() {
            const thisRequiredField = $(this);
            const formInput = thisRequiredField.find('.form-input');

            if (!thisRequiredField.hasClass('form-field-email') && thisRequiredField.is(':visible') && (formInput.val() === '' || formInput.val() === null)) {
              hasError = true;

              thisRequiredField.addClass('form-field-error');
              thisRequiredField.append('<div class="form-field-notice form-field-error-message">This field is required</div>');
            }
          });
        }

        if (hasError) {
          formMessage.addClass('has-error');
          formMessage.html('Validation failed. Please check required fields.');
          formMessage.show();

          return false;
        } else {
          thisCampaignsAndSalesOptInForm.find('button[type="submit"]').prop('disabled', true);
          thisCampaignsAndSalesOptInForm.addClass('loading');
        }
      });

      // Handle date range picker script
      const handleDateRangePickerScript = function(thisPickerWrap) {
        const thisPicker = thisPickerWrap.find('input');
        const singleDatePicker = thisPickerWrap.hasClass('single-date-picker');
        const pickerVal = thisPicker.val();
        let startDate = moment().startOf('day');
        let endDate = moment().add(1, 'day');

        thisPicker.attr('autocomplete', 'off');

        if (pickerVal !== '') {
          if (singleDatePicker) {
            const pickerStartDate = moment(pickerVal, constants.DATE_FORMAT_IN_VIEW).format(constants.DATE_FORMAT_ISO);

            startDate = pickerStartDate;
          } else {
            const pickerValArr = pickerVal.split(' - ');
            const pickerStartDate = moment(pickerValArr[0], constants.DATE_FORMAT_IN_VIEW).format(constants.DATE_FORMAT_ISO);
            const pickerEndDate = moment(pickerValArr[1], constants.DATE_FORMAT_IN_VIEW).format(constants.DATE_FORMAT_ISO);

            startDate = pickerStartDate;
            endDate = pickerEndDate;
          }
        }

        thisPicker.daterangepicker({
          startDate: startDate,
          endDate: endDate,
          singleDatePicker: singleDatePicker,
          autoUpdateInput: false,
          autoApply: true,
          linkedCalendars: true,
          locale: {
            cancelLabel: 'Clear',
          },
        });

        thisPicker.on('apply.daterangepicker', function(ev, picker) {
          const start = picker.startDate.format(constants.DATE_FORMAT_IN_VIEW);
          const dataDateRangePicker = thisPicker.data('daterangepicker');

          if (dataDateRangePicker.singleDatePicker) {
            thisPicker.val(start);
            thisPicker.trigger('input');
          } else {
            const end = picker.endDate.format(constants.DATE_FORMAT_IN_VIEW);

            thisPicker.val(`${start} - ${end}`);
            thisPicker.trigger('input');
          }
        });

        // Trigger on cancel
        thisPicker.on('cancel.daterangepicker', function() {
          thisPicker.val('');
        });
      };

      // Message url parameter after submitting the form
      const message = helpers.getParameterByName('message');
      if (message != null && message.length) {
        const url = helpers.removeParameter('message');

        helpers.pushStateHistory(url, true);
      }

      // Hotels select
      const campaignAndSaleHotelsSelect = campaignsAndSalesOptInForm.find('.campaign-and-sale-hotels');
      if (campaignAndSaleHotelsSelect.length) {
        campaignAndSaleHotelsSelect.on('change', function() {
          const selectedHotels = campaignAndSaleHotelsSelect.val();
          const selectedHotelDivs = campaignsAndSalesOptInForm.find('.campaign-and-sale-selected-hotel');

          selectedHotelDivs.hide();

          if (selectedHotels) {
            for (let i = 0; i < selectedHotels.length; i++) {
              const val = selectedHotels[i];
              const selectedHotelDiv = campaignsAndSalesOptInForm.find(`.campaign-and-sale-selected-hotel[data-blog-id="${val}"]`);

              if (selectedHotelDiv.length) {
                selectedHotelDiv.show();
              }
            }
          }
        });
      }

      // Checkboxes toggle
      const checkboxWrapper = campaignsAndSalesOptInForm.find('.checkbox-wrapper');
      if (checkboxWrapper.length) {
        checkboxWrapper.each(function() {
          const thisCheckboxWrapper = $(this);

          thisCheckboxWrapper.find('input[type="checkbox"]').on('change', function() {
            const _this = $(this);
            const hideShowElements = thisCheckboxWrapper.data('hide-show-elements');

            if (hideShowElements && campaignsAndSalesOptInForm.find(hideShowElements).length) {
              if (_this.is(':checked')) {
                // Show the elements
                campaignsAndSalesOptInForm.find(hideShowElements).show();
              } else {
                // Hide the elements
                campaignsAndSalesOptInForm.find(hideShowElements).hide();
              }
            }
          });
        });
      }

      // Repeaters
      const repeaterWrapper = campaignsAndSalesOptInForm.find('.repeater-container');
      if (repeaterWrapper.length) {
        repeaterWrapper.each(function() {
          const thisRepeaterWrapper = $(this);
          const addButton = thisRepeaterWrapper.find('.controls .control-button.add-button');
          const deleteButton = thisRepeaterWrapper.find('.controls .control-button.delete-button');

          // Remove a repeater item
          deleteButton.on('click', function(e) {
            e.preventDefault();

            const _this = $(this);
            const thisRepeaterItemWrapperParent = _this.closest('.repeater-item');

            thisRepeaterItemWrapperParent.remove();
          });

          // Add a repeater item
          addButton.on('click', function(e) {
            e.preventDefault();

            const _this = $(this);
            const thisRepeaterItemWrapperParent = _this.closest('.repeater-item');
            const repeaterItemWrapperClone = thisRepeaterWrapper.find('.repeater-item.cloner');

            thisRepeaterItemWrapperParent.after(repeaterItemWrapperClone.clone(true).removeClass('cloner').addClass('cloned'));
            $(document).trigger('campaign_and_sale_repeater_item_added.rydges');
          });

          $(document).on('campaign_and_sale_repeater_item_added.rydges', function() {
            const repeaterItemCloned = thisRepeaterWrapper.find('.repeater-item.cloned');
            const clonedDateRangePickerWrapper = repeaterItemCloned.find('.date-range-picker-wrapper');

            if (clonedDateRangePickerWrapper.length) {
              handleDateRangePickerScript(clonedDateRangePickerWrapper);
              repeaterItemCloned.removeClass('cloned');
            }
          });
        });
      }

      // Date range pickers
      const dateRangePickerWrapper = campaignsAndSalesOptInForm.find('.date-range-picker-wrapper');
      if (dateRangePickerWrapper.length) {
        dateRangePickerWrapper.each(function () {
          const thisPickerWrap = $(this);

          if (thisPickerWrap.closest('.repeater-item.cloner').length === 0) {
            handleDateRangePickerScript(thisPickerWrap);
          }
        });
      }

      // Is single day checkboxes
      $(document).on('change', '.hotel-black-out-days-is-single-day-checkbox', function() {
        const _this = $(this);
        const thisDateRangePickerWrapper = _this.closest('.repeater-item').find('.date-range-picker-wrapper');
        const thisDateRangePicker = thisDateRangePickerWrapper.find('input');
        const dataDateRangePicker = thisDateRangePicker.data('daterangepicker');

        if (dataDateRangePicker) {
          if (_this.is(':checked')) {
            dataDateRangePicker.singleDatePicker = true;
            dataDateRangePicker.endDate = dataDateRangePicker.startDate;

            const start = dataDateRangePicker.startDate.format(constants.DATE_FORMAT_IN_VIEW);

            thisDateRangePicker.val(start);
            thisDateRangePicker.trigger('input');
          } else {
            dataDateRangePicker.singleDatePicker = false;
            dataDateRangePicker.endDate = moment(dataDateRangePicker.startDate).add(1, 'day').endOf('day');

            const start = dataDateRangePicker.startDate.format(constants.DATE_FORMAT_IN_VIEW);
            const end = dataDateRangePicker.endDate.format(constants.DATE_FORMAT_IN_VIEW);

            thisDateRangePicker.val(`${start} - ${end}`);
            thisDateRangePicker.trigger('input');
          }
        }
      });

      // Other inclusions checkbox
      const hotelInclusionsOtherCheckbox = campaignsAndSalesOptInForm.find('.hotel-inclusions-other-checkbox');
      if (hotelInclusionsOtherCheckbox.length) {
        hotelInclusionsOtherCheckbox.each(function() {
          const thisHotelInclusionsOtherCheckbox = $(this);

          thisHotelInclusionsOtherCheckbox.on('change', function() {
            const hotelOtherInclusionsElement = thisHotelInclusionsOtherCheckbox.closest('.campaign-and-sale-selected-hotel').find('.hotel-other-inclusions-element');

            if (hotelOtherInclusionsElement.length) {
              if (this.checked) {
                hotelOtherInclusionsElement.show();
              } else {
                hotelOtherInclusionsElement.hide();
              }
            }
          });
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptCampaignsSales.js